export const Palette = {
    gray: {
        gray50: '#F9F9F9',
        gray75: '#F7F7F7',
        gray100: '#F2F2F2',
        gray150: '#EDEDED',
        gray200: '#E8E8E8',
        gray300: '#D8D8D8',
        gray400: '#B4B4B4',
        gray500: '#949494',
        gray600: '#6C6C6C',
        gray700: '#4D4D4D',
        gray800: '#333333',
        gray900: '#1A1A1A',
    },
    green: {
        green50: '#E5F9EB',
        green100: '#BFEECD',
        green200: '#94E4AE',
        green300: '#5FD98C',
        green400: '#23D071',
        green500: '#00C656',
        green600: '#00B64B',
        green700: '#00A33F',
        green800: '#009232',
        green900: '#00721E',
    },
    yellow: {
        yellow50: '#FFF8DF',
        yellow100: '#FFEBAF',
        yellow200: '#FFDF7B',
        yellow300: '#FFD342',
        yellow400: '#FFC800',
        yellow500: '#FFBE00',
        yellow600: '#FFB000',
        yellow700: '#FF9C00',
        yellow800: '#FF8A00',
        yellow900: '#FF6800',
    },
    red: {
        red50: '#FFEDF0',
        red100: '#FFD2D8',
        red200: '#F8A2A3',
        red300: '#F27E7F',
        red400: '#FF615E',
        red500: '#FF5144',
        red600: '#F74A44',
        red700: '#E5403D',
        red800: '#D73936',
        red900: '#C82E2A',
    },
    blue: {
        blue50: '#E3F0FF',
        blue100: '#BCD9FF',
        blue200: '#91C3FF',
        blue300: '#66ABFF',
        blue400: '#4A99FF',
        blue500: '#3F87F9',
        blue600: '#4079EA',
        blue700: '#3F67D5',
        blue800: '#3D55C2',
        blue900: '#3A359F',
    },
    violet: {
        violet50: '#F3E6FE',
        violet100: '#DDC2FB',
        violet200: '#C697FA',
        violet300: '#AF69F9',
        violet400: '#9B3FF7',
        violet500: '#8600F4',
        violet600: '#7A00ED',
        violet700: '#6A00E5',
        violet800: '#5900E0',
        violet900: '#3F00D2',
    },
    white: '#FFFFFF',
    black: '#000000',

    boxShadow: {
        elevation1: '0 4px 12px -2px rgba(0, 0, 0, 0.02), 0 4px 6px -4px rgba(0, 0, 0, 0.02)',
        elevation2: '0 6px 16px -2px rgba(0, 0, 0, 0.04), 0 6px 8px -4px rgba(0, 0, 0, 0.03)',
        elevation3: '0 12px 28px -2px rgba(0, 0, 0, 0.08), 0 6px 8px -4px rgba(0, 0, 0, 0.05)',
        elevation4: '0 12px 33px -2px rgba(0, 0, 0, 0.09), 0 8px 10px -6px rgba(0, 0, 0, 0.06)',
        elevation6: '0 14px 40px -2px rgba(0, 0, 0, 0.10), 0 10px 10px -8px rgba(0, 0, 0, 0.06)',
        elevation8: '0 14px 48px -2px rgba(0, 0, 0, 0.14), 0 8px 12px -8px rgba(0, 0, 0, 0.06)',
        elevation12: '0 16px 56px -2px rgba(0, 0, 0, 0.16), 0 9px 15px -8px rgba(0, 0, 0, 0.08)',
        elevation16: '0 18px 62px -2px rgba(0, 0, 0, 0.18), 0 10px 16px -11px rgba(0, 0, 0, 0.08)',
        elevation20: '0 20px 72px -2px rgba(0, 0, 0, 0.28), 0 12px 18px -12px rgba(0, 0, 0, 0.10)',
    },
};
